export default __webpack_public_path__ + "static/media/vitasis-logo.7d582404.svg";